<template>
	<div class="d-flex align-items-center justify-content-between w-100 topDiv">
		<label
			id="hideinmobile"
			class="teams-label-font w-40"
			:class="{ active: isFocused || selectedCity }"
			>{{ label }}<span v-if="mandatory" class="asterik">*</span></label
		>
		<div ref="customSelect" class="w-100 position-relative">
			<div class="floating-label">
				<input
					v-if="
						type == 'text' ||
						$route.query.formID == 'education' ||
						$route.query.formID == 'experience' ||
						id == 'location'
					"
					:placeholder="placeholder"
					:id="'autocomplete' + id"
					v-model.trim="selectedCity"
					:type="type"
					:class="showError ? 'laptopinput-error' : 'laptopinput'"
					class="w-100 cityinput"
					@input="(showOptions = true), $emit('select-value', selectedCity)"
					@focus="openDropdown(), (isFocused = true)"
				/>
				<b-form-textarea
					v-else
					:id="'autocomplete' + id"
					:class="showError ? 'candash-textarea-error' : 'candash-textarea'"
					type="text"
					rows="3"
					max-rows="4"
					v-model.trim="selectedCity"
					@keyup="$emit('select-value', selectedCity)"
					@focus="openDropdown(), (isFocused = true)"
				>
				</b-form-textarea>
				<label id="hideinlaptop" :class="{ active: isFocused || selectedCity }"
					>{{ label
					}}<span v-if="mandatory" class="asterik">&nbsp;*</span></label
				>
			</div>
			<!-- Custom dropdown for city suggestions -->
			<ul
				id="autocomplete-dropdown"
				:class="
				    from == 'onboarding' ? 'select-options mheight-115px'
						:type != 'text' && id == 'permenant'
						? 'permanent-select-options'
						: type != 'text' && id == 'current'
						? 'current-select-options'
						: id == 'eduloc'
						? 'eduloc-select-options'
						: 'select-options'
				"
				v-if="showOptions && citySuggestions.length > 0"
			>
				<li
					v-for="(city, index) in citySuggestions"
					:key="city + index"
					:class="{ selected: selectedCityObj.city === city.city }"
					@click="(selectedCityObj = city), selectCity(city.city)"
					class="search-select-option"
				>
					{{ city.city }}, {{ city.state }}
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "Location",
	data() {
		return {
			dataLocation: "",
			selectedCity: "",
			selectedState: "",
			citySuggestions: [],
			showOptions: false,
			selectedCityObj: {},
			isFocused: false,
		};
	},
	props: {
		label: String,
		form: Object,
		selOption: String,
		type: String,
		id: String,
		placeholder: String,
		mandatory: Boolean,
		showError: Boolean,
		from: String,
		vmodel: {
			validator: function () {
				return true;
			},
		},
	},
	watch: {
		selOption(newValue, oldValue) {
			if (newValue !== oldValue) {
				this.selectedCity = newValue;
			}
		},
		id(newValue, oldValue) {
			if (newValue !== oldValue) {
				this.initialize();
			}
		},
		vmodel(newValue) {
			this.selectedCity = newValue;
		},
	},
	computed: {
		...mapGetters("candidateVUEX", {
			allValidation: "getAllValidation",
		}),
	},
	mounted() {
		this.initialize();
		if (this.vmodel) {
			this.selectedCity = this.vmodel;
			this.$emit("select-value", this.selectedCity);
		}
	},
	beforeDestroy() {
		document.removeEventListener("keydown", this.handleKeyPressText);
		document.removeEventListener("click", this.closeDropdownOnClickOutside);
	},
	methods: {
		initialize() {
			this.selectedCity = this.selOption;
			this.$nextTick(function () {
				const input = document.getElementById("autocomplete" + this.id);
				const autocompleteService =
					new window.google.maps.places.AutocompleteService();

				input.addEventListener("input", () => {
					if (input.value.length > 0) {
						autocompleteService.getPlacePredictions(
							{
								input: input.value,
								types: ["(cities)"],
								language: "en",
							},
							(predictions, status) => {
								if (
									status === window.google.maps.places.PlacesServiceStatus.OK
								) {
									this.citySuggestions = predictions.map((prediction) => ({
										city: prediction.terms[0]?.value,
										state: prediction.terms[1]?.value || "",
									}));
								}
							}
						);
					} else {
						this.citySuggestions = [];
					}
				});

				input.addEventListener("keydown", this.handleKeyPressText);
				document.addEventListener("click", this.closeDropdownOnClickOutside);
			});
		},
		handleKeyPressText(event) {
			if (event.key === "ArrowDown") {
				event.preventDefault();
				const selectedIndex = this.getSelectedIndex();
				const nextIndex = selectedIndex + 1;

				if (nextIndex < this.citySuggestions.length) {
					this.setSelectedIndex(nextIndex);
					this.scrollIntoView();
				}
			} else if (event.key === "ArrowUp") {
				event.preventDefault();
				const selectedIndex = this.getSelectedIndex();
				const prevIndex = selectedIndex - 1;

				if (prevIndex >= 0) {
					this.setSelectedIndex(prevIndex);
					this.scrollIntoView();
				}
			} else if (event.key === "Enter") {
				this.showOptions = false;
				this.$emit("select-city", this.selectedCity);
			}
		},
		getSelectedIndex() {
			return this.citySuggestions.findIndex(
				(city) => city.city === this.selectedCityObj?.city
			);
		},
		setSelectedIndex(index) {
			this.selectedCityObj = this.citySuggestions[index];
			this.selectedCity = this.citySuggestions[index].city;
			this.$emit("select-value", this.selectedCity);
		},
		scrollIntoView() {
			const selectedOptionElement = document.querySelector(
				".search-select-option.selected"
			);
			if (selectedOptionElement) {
				selectedOptionElement.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
				});
			}
		},
		closeDropdownOnClickOutside(event) {
			if (!this.$refs.customSelect.contains(event.target)) {
				this.showOptions = false;
			}
		},
		openDropdown() {
			this.showOptions = true;
		},
		selectCity(city) {
			this.selectedCity = city;
			this.$emit("select-value", city);
			this.showOptions = false;
		},
	},
};
</script>

<style scoped>
.cityinput {
	height: 38px !important;
}
.cityinput:focus-visible {
	outline: none;
}
.cityinput::placeholder {
	font-size: 13px;
}
.search-select-option.selected {
	background-color: #f0f0f0;
	color: #333;
}
@media (max-width: 1028px) {
	.cityinput::placeholder {
		color: #fff;
	}
}
.eduloc-select-options {
	position: absolute;
	top: 32px;
	left: 2px;
	background-color: #fff;
	border-top: none;
	border-radius: 4px;
	padding: 0;
	list-style: none;
	width: 98%;
	overflow-y: auto;
	z-index: 3;
	border: 1px solid #2988e638;
	box-shadow: 0px 8px 15px 0px #00000066;
}
.eduloc-select-options .select-option:first-child {
	/* Your styles for the first <li> element */
	color: #8c8c8c !important;
	font-size: 12px !important;
	font-weight: 400;
	font-family: "montserrat", sans-serif;
	background-color: transparent;
}

.current-select-options {
	position: absolute;
	bottom: 46px;
	left: 15px;
	background-color: #fff;
	border-top: none;
	border-radius: 4px;
	padding: 0;
	list-style: none;
	width: 98%;
	overflow-y: auto;
	z-index: 3;
	border: 1px solid #2988e638;
	box-shadow: 0px -3px 15px 0px #00000066;
}
.current-select-options .select-option:first-child {
	/* Your styles for the first <li> element */
	color: #8c8c8c !important;
	font-size: 12px !important;
	font-weight: 400;
	font-family: "montserrat", sans-serif;
	background-color: transparent;
}

.permanent-select-options {
	position: absolute;
	bottom: 60px;
	left: 15px;
	background-color: #fff;
	border-top: none;
	border-radius: 4px;
	padding: 0;
	list-style: none;
	width: 98%;
	overflow-y: auto;
	z-index: 3;
	border: 1px solid #2988e638;
	box-shadow: 0px -3px 15px 0px #00000066;
}
.permanent-select-options .select-option:first-child {
	/* Your styles for the first <li> element */
	color: #8c8c8c !important;
	font-size: 12px !important;
	font-weight: 400;
	font-family: "montserrat", sans-serif;
	background-color: transparent;
}
.mheight-115px {
	max-height: 115px !important;
}
</style>
